import _ from 'lodash'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Schema } from 'features/globalSetup/features/amazon/forms/GeneralPageForm'
import { useAbility } from 'providers/casl'
import { Props, TooltipProps, UseSwitchProps } from './types'
import { DISABLED_NO_TOOLTIP, ENABLED_NO_TOOLTIP } from './utilts'

export const useSwitchProps = ({ workspaceAmazon }: Props): UseSwitchProps => {
  const ability = useAbility()
  const { t } = useTranslation(['features/globalSetup/amazon', 'common'])

  const { control, getFieldState } = useFormContext<Schema>()

  const tooltipProps = (): TooltipProps => {
    if (ability.cannot('update', 'GlobalSetupFeature-amazon')) {
      return DISABLED_NO_TOOLTIP
    }

    if (_.isNil(workspaceAmazon)) {
      return {
        disabled: true,
        tooltip: {
          content: t('pages.general.amazonOnOff.tooltip.disabled'),
        },
      }
    }

    return getFieldState('pubId').invalid ? DISABLED_NO_TOOLTIP : ENABLED_NO_TOOLTIP
  }

  return {
    control,
    name: 'enabled',
    tooltipMode: 'wrap',
    ...tooltipProps(),
  }
}
